import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-301f70e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-namespace-form" }
const _hoisted_2 = { class: "create-namespace-form__buttons" }

import { ref, computed, Ref } from 'vue';
import { BaseNamespaceForm, BaseNamespaceFormDataModel } from '../base-namespace-form';
import { CreateNamespaceModel, CreateNamespaceResultModel } from './models';
import {
  TirPmButton,
  TirPmButtonVariantEnum,
  TirPmNotificationEventBus,
  TirPmNotificationModel,
} from 'tir-components';
import { AdapterService } from './adapter';


export default /*#__PURE__*/_defineComponent({
  __name: 'create-namespace-form',
  props: {
  /**ID проекта */
  projectId: {
    type: Number,
    required: true,
  },
},
  emits: ["onCancel", "onCreate", "tooltipElementVisibleState"],
  setup(__props, { emit }) {

const props = __props;



const adapter = new AdapterService();



/**Данные для создания рабочей области */
const createFormData = ref<CreateNamespaceModel>();

/**Данные для базовой формы рабочей области */
const baseNamespaceFormData = computed({
  get() {
    if (createFormData.value)
      return new BaseNamespaceFormDataModel({
        Name: createFormData.value.Name,
        IconId: createFormData.value.IconId,
        IconColorId: createFormData.value.IconColorId,
        AdminIds: createFormData.value.AdminIds,
        TeamIds: createFormData.value.TeamIds,
        IconColor: createFormData.value.IconColor,
        IconUrl: createFormData.value.IconUrl,
      });
  },
  set(value) {
    createFormData.value = new CreateNamespaceModel({
      Name: value.Name,
      IconId: value.IconId,
      IconColorId: value.IconColorId,
      AdminIds: value.AdminIds,
      TeamIds: value.TeamIds,
      IconUrl: value.IconUrl,
      IconColor: value.IconColor,
    });
  },
});

/**Состояние видимости TooltipElement */
let tooltipElementVisibleState;

/**Загрузка */
const isLoading = ref(false);

/**Нет доступа создания рабочей области */
const disabledCreateNamespace = computed(
  () => baseNamespaceFormData.value?.Name && baseNamespaceFormData.value?.IconId,
);

/**Добавить оповещение */
const addNotification = (message: string, isError: boolean = false, life?: number) => {
  TirPmNotificationEventBus.emit(
    'add',
    new TirPmNotificationModel({
      title: message,
      type: isError ? 'error' : 'success',
      group: 'general',
      life: life ?? 2000,
      closable: true,
    }),
  );
};
/**Создание неймспейса */
const createNamespace = async () => {
  isLoading.value = true;
  if (createFormData.value) {
    const resp = await adapter.createNamespace(createFormData.value, props.projectId);
    tooltipElementVisibleState = false;
    if (resp.IsSuccess) {
      emit('onCreate', resp.Value);
      addNotification('Рабочая область создана');
    } else {
      addNotification(resp.ErrorMessage, true);
    }
  } else {
    tooltipElementVisibleState = true;
  }
  emit('tooltipElementVisibleState', tooltipElementVisibleState);
  isLoading.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(BaseNamespaceForm), {
      modelValue: baseNamespaceFormData.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((baseNamespaceFormData).value = $event))
    }, null, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(TirPmButton), {
        variant: _unref(TirPmButtonVariantEnum).PrimaryState,
        isLoading: isLoading.value,
        isDisabled: !disabledCreateNamespace.value,
        onClick: createNamespace
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Создать ")
        ]),
        _: 1
      }, 8, ["variant", "isLoading", "isDisabled"]),
      _createVNode(_unref(TirPmButton), {
        variant: _unref(TirPmButtonVariantEnum).SecondaryState,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('onCancel')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Отмена ")
        ]),
        _: 1
      }, 8, ["variant"])
    ])
  ]))
}
}

})